(function () {
    'use strict';

    function workflowSharingSearchController($scope, $rootScope, $timeout, $filter, $state, sessionData, milestones,
        workflowStateService, milestoneModalService, notifyService, entitySearchConfiguration, mailRequestDataService) {
        var vm = this;
        vm.path = $rootScope.$state.params.path;
        vm.workflowId = $rootScope.$state.params.workflowId;
        vm.returnToPhaseIndex = parseInt($rootScope.$state.params.phaseIndex, 10);
        vm.returnToState = $rootScope.$state.params.phaseIndex ? 'workflow.phase'
            : vm.path.indexOf('InternalContent') !== -1 ? 'workflow.internalfiles' : 'workflow';
        vm.config = entitySearchConfiguration;
        vm.results = [];
        vm.showResults = false;
        vm.attributes = {};
        vm.workflow = workflowStateService.get();
        vm.isAdmin = sessionData.IsAdminEntity;
        vm.sessionData = sessionData;
        vm.pageIndex = 0;
        vm.pageSize = 5;
        if (entitySearchConfiguration && entitySearchConfiguration.DefaultPageSize) {
            vm.pageSize = entitySearchConfiguration.DefaultPageSize;
        };

        vm.totalItems = 0;
        vm.currentPartners = workflowStateService.getPartners(vm.path);
        vm.selectedEntityIds = [];
        vm.searchControlId = 'workflowSharingSearch';
        vm.sessionData = sessionData;
        vm.isPortalAdmin = vm.sessionData.EntityType === 'Portal Administrator';

        vm.isSearchHidden = false;

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                if (!entitySearchConfiguration) {
                    milestonesAndTemplates = milestonesAndTemplates.filter(function(milestoneAndTemplate) {
                        return milestoneAndTemplate.milestoneName !== 'PartnerSearchWizard';
                    });
                }
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        vm.toggleSearchVisibility = function (referralSent) {
            vm.isSearchHidden = !vm.isSearchHidden;
            var stateName;
            var stateObject;
            if (referralSent) {
                switch (vm.returnToState) {
                    case ('workflow'):
                        stateName = 'workflow.navigator';
                        stateObject = { workflowId: vm.workflowId }
                        break;
                    case ('workflow.phase'):
                        stateName = 'workflow.navigator.phase';
                        stateObject = {
                            workflowId: vm.workflowId,
                            phaseIndex: vm.returnToPhaseIndex
                        };
                        break;
                    case ('workflow.internalfiles'):
                        stateName = 'workflow.internalfiles';
                        stateObject = { workflowId: vm.workflowId };
                        break;
                }
            }

            if (stateName && stateObject) {
                $state.go(stateName, stateObject);
            }
        }

        vm.referralData = {
            platformId: vm.workflow.Entity.PlatformId,
            siteConfigurationId: vm.workflow.Entity.SiteConfigurationId,
            referrerEntityId: vm.sessionData.EntityId,
            objectType: 'Workflow',
            objectId: vm.workflow.Id,
            objectReferralPath: vm.path,
            objectReferralMessage: 'You were invited to share ' +
                (vm.path === ''
                ? ('the project ' + vm.workflow.Name)
                : (workflowStateService.getCleanPath(vm.path) + ' of the project ' + vm.workflow.Name))
        }

        vm.hasAdminEntitySearch = sessionData.IsAdminEntity && $rootScope.$state.params.adminEntitySearchIndex;
        vm.adminEntitySearchIndex = $rootScope.$state.params.adminEntitySearchIndex;
        vm.entitySearchIndex = $rootScope.$state.params.entitySearchIndex;
        vm.hideReferralButton = true;

        vm.mode = 'workflow-sharing-search-mode-invite';
        if (vm.config) {
            vm.mode += '-sharing';
        }
        if (vm.hasAdminEntitySearch) {
            vm.mode += '-adminsharing';
        }

        vm.additionalQueryString = "workflowId=" + vm.workflow.Id.split('/')[1];
        if (vm.currentPartners.length !== 0) {
            vm.additionalQueryString += "&excludeEntityIds=" + vm.currentPartners.map(function(partner) { return encodeURIComponent(partner.Id); }).join(',');
        }

        vm.toggleSharingConnection = function (partner) {
            var matchingPartner = vm.workflow.SharingConnections.find(function (connection) {
                return connection.EntityId === partner.Id;
            });

            var addedConnection = false;
            if (matchingPartner) {
                if (matchingPartner.PathsAndPermissions.find(function(pathAndPermissions) {
                    return pathAndPermissions.Path === vm.path;
                })) {
                    matchingPartner.PathsAndPermissions = matchingPartner.PathsAndPermissions.filter(function (pathAndPermissions) {
                        return pathAndPermissions.Path !== vm.path;
                    });
                    partner.isSelected = false;
                    notifyService.notify('You unshared ' + workflowStateService.getCleanPath(vm.path) + ' with ' + matchingPartner.Entity.CompanyDetails.Name);
                }
                else {
                    matchingPartner.PathsAndPermissions.push({
                        Path: vm.path,
                        Permissions: {
                            View: true,
                            Edit: false,
                            Share: false,
                            Notes: false
                        }
                    });
                    partner.isSelected = true;
                    notifyService.notify('You shared ' + workflowStateService.getCleanPath(vm.path) + ' with ' + matchingPartner.Entity.CompanyDetails.Name);
                    addedConnection = true;
                }
            } else {
                vm.workflow.SharingConnections.push({
                    EntityId: partner.Id,
                    PathsAndPermissions: [
                    {
                        Path: vm.path,
                        Permissions: {
                            View: true,
                            Edit: false,
                            Share: false,
                            Notes: false
                        }
                    }],
                    Entity: partner
                });
                partner.isSelected = true;
                notifyService.notify('You shared ' + workflowStateService.getCleanPath(vm.path) + ' with ' + partner.CompanyDetails.Name);
                addedConnection = true;
            }

            // update sharing partners for path
            updatePartners(vm.workflow, vm.path, partner);
            workflowStateService.update(vm.workflow);

            if (addedConnection) {
                mailRequestDataService.sendWorkflowSharingUpdate({
                    EntityId: vm.workflow.Entity.Id,
                    SharedWithEntityId: partner.Id,
                    WorkflowId: vm.workflow.Id
                });
            }

            var toggledEntityIdIndex = vm.selectedEntityIds.indexOf(partner.Id);
            if (toggledEntityIdIndex === -1) {
                vm.selectedEntityIds.push(partner.Id);
            }
            else {
                vm.selectedEntityIds.splice(toggledEntityIdIndex,1);
            }
        }

        vm.requestIntroduction = function (partner) {
            mailRequestDataService.sendConnectionRequest({
                RequesterEntityId: vm.workflow.Entity.Id,
                RequesteeEntityId: partner.Id
            });
            notifyService.notify('You requested an introduction with ' + partner.CompanyDetails.Name);
        }

        vm.actions = {
            togglePartnerIntroduction: {
                label: "Connect",
                call: vm.requestIntroduction
            },
            toggleSharingConnection: {
                label: "Share",
                call: vm.toggleSharingConnection,
                cssClass: "md-primary"
            }
        }

        vm.pageSizes = [5, 10, 15, 20, 25];

        vm.changePageIndex = function () {
            $rootScope.$emit('pageIndexChanged', { searchControlId: vm.searchControlId, pageIndex: vm.pageIndex });
        }

        vm.changePageSize = function () {
            vm.pageIndex = 0;
            $rootScope.$emit('pageSizeChanged', { searchControlId: vm.searchControlId, pageSize: vm.pageSize, pageIndex: vm.pageIndex });
        }

        function updatePartners(obj, path, partner) {
            var k;
            var has = Object.prototype.hasOwnProperty.bind(obj);
            for (k in obj) if (has(k)) {
                switch (typeof obj[k]) {
                    case "object":
                        if (obj[k] != null && obj[k]["Path"]) {
                            if (obj[k]["Path"] === path) {
                                if (!obj[k]["Partners"]) {
                                    obj[k]["Partners"] = [];
                                }
                                obj[k]["Partners"].push(partner);
                            }
                        }
                        else {
                            updatePartners(obj[k], path, partner);
                        }
                        break;
                }
            }
        };

        vm.activateReferral = function() {
            $rootScope.$emit('platformEntityReferralGeneratorActivated');
        };

        $rootScope.$on('searchResultsChanged', function(event, args) {
            if (args.searchControlId === vm.searchControlId) {
                vm.results = args.results;
                vm.totalItems = args.totalItems;
                vm.results = vm.results.map(function (item) {
                    item.isSelected = vm.selectedEntityIds.indexOf(item.Id) !== -1;
                    return item;
                });
            }
        });
    }

    workflowSharingSearchController.$inject = ['$scope', '$rootScope', '$timeout', '$filter', '$state', 'sessionData', 'milestones',
        'workflowStateService', 'milestoneModalService', 'notifyService', 'entitySearchConfiguration', 'mailRequestDataService'];

    angular.module('ecap.workflow').controller('workflowSharingSearchController', workflowSharingSearchController);
})();
